import React, { useState } from "react";
import "./EVLoader.css";

export default class EVLoader extends React.Component {
  constructor(props) {
    super();
    this.state = { seconds: 1 };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  componentDidMount() {
    if (this.props.isLoading) {
      let timeLeftVar = this.secondsToTime(this.state.seconds);
      this.setState({ time: timeLeftVar });
    }
  }

  startTimer() {
    if (this.timer == 0 && this.state.seconds <= 1) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  componentDidMount() {
    this.startTimer();
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds + 1;
    this.setState({
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds == 20) {
      clearInterval(this.timer);
    }
  }

  render() {
    return (
      <div className="progressLoader">
        <div className="bar" style={{width:this.state.seconds*5+"%"}}>
          <p className="percent">{this.state.seconds>2?this.state.seconds*5+"%":""}</p>
        </div>
      </div>
    );
  }
}
